import { Components, Theme } from '@mui/material';

const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    select: ({ theme }) => ({
      color: theme.palette.text.primary,
      padding: theme.spacing(
        theme.spacingSizes.xs,
        9,
        theme.spacingSizes.xs,
        theme.spacingSizes.sm,
      ),
      fontSize: theme.fontSizes.regular,
      fontWeight: theme.typography.fontWeightMedium,
      lineHeight: '24px',
    }),
  },
};

export default MuiSelect;
